app.controller('esEntityLookupP2DrugRPController', ['$scope', 'p2DrugModel',
    function ($scope, p2DrugModel) {
        $scope.$on(Event.P2_DRUG.GET_DATA_PAGE.SUCCESS, function (event, dataPage, code) {
            $scope.items = dataPage.data;
            $scope.lookupInProgress = false;
        });

        $scope.getData = function (s) {
            if(s) {
                var criteria = {rowsPerSheet: 10, searchPhrase: s };
                criteria.availabilityCategory = 'RP';
                p2DrugModel.getDataPage(criteria);
                $scope.lookupInProgress = true;
            } else {
                $scope.items = [];
            }
        };

        $scope.getLabel = function(item) {
            if(item) {
                return item.name + ' (' + item.strength + ', ' + item.form + ')';
            }
        };

    }
]);
